import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import TeamMembers from "@/pages/admin/TeamMembers";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/team-members/")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-team", path: "/admin/team-members", title: "Cloud Admin Team", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><TeamMembers /></AdminLayout>,
});
